import { useState, useRef } from "react"
import ReactPlayer from "react-player"

const useVideoProgressManager = () => {
  const [videoProgress, setVideoProgress] = useState({
    playedSeconds: 0,
    played: 0,
    loadedSeconds: 0,
    loaded: 0,
  })

  const videoPlayerRef = useRef<ReactPlayer>()

  const seekToTimestamp: (timestamp: number) => void = (timestamp) => {
    if (videoPlayerRef.current) {
      videoPlayerRef.current.seekTo(timestamp, "seconds")
    }

    setVideoProgress((prevState) => ({
      ...prevState,
      playedSeconds: timestamp,
    }))
  }

  return { videoProgress, setVideoProgress, videoPlayerRef, seekToTimestamp }
}

export default useVideoProgressManager
